import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Select } from '@amzn/stencil-react-components/select';
import { InputWrapper } from '@amzn/stencil-react-components/input';
import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import cloneDeep from 'lodash/cloneDeep';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { updateActiveFilters, updateEmployeeJobLevel } from '../../../actions/ruleFiltersActions';
import { JOB_LEVEL_INFO, SegmentFilters } from '../../../constants/createSegment';
import {
  activeRuleFiltersSelector,
  initialDataSelector,
  ruleFilterEmployeeJobLevelSelector,
} from '../../../selectors/selectors';
import MultiSelectInput from '../../atoms/MultiSelectInput';
import { IconInformationSmall } from '@amzn/stencil-react-icons';

const IconWithTooltip = withTooltip()(IconInformationSmall);
const EmployeeJobLevelFilter = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const employeeJobLevels = useSelector(ruleFilterEmployeeJobLevelSelector);
  const { jobLevels } = useSelector(initialDataSelector);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.EMPLOYEE_JOB_LEVEL_FILTER),
  );

  const onFilterChange = e => {
    setIsDisabled(!e?.target?.checked);
    let currentFilter = cloneDeep(activeFilters);
    currentFilter = currentFilter.filter(f => f !== SegmentFilters.EMPLOYEE_JOB_LEVEL_FILTER);
    if (e.target.checked) {
      currentFilter.push(SegmentFilters.EMPLOYEE_JOB_LEVEL_FILTER);
      dispatch(updateActiveFilters(currentFilter));
    } else {
      dispatch(updateEmployeeJobLevel([]));
      dispatch(updateActiveFilters(currentFilter));
    }
  };

  const onJobLevelChange = e => {
    dispatch(updateEmployeeJobLevel(e));
  };
  return (
    <>
      <Row gridGap="S100">
        <Checkbox
          data-testid="rule-filter-5"
          checked={!isDisabled}
          onChange={e => onFilterChange(e)}
        />
        <Label display="flex" fontSize={'T300'} htmlFor="rule-filter-5" id="rule-filter-label5">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage
              id="app.ruleFilter.label.employeeJobLevel"
              defaultMessage="Employee Job Level"
            />
          </Text>

          <Spacer width="10px" />
          <IconWithTooltip title="Country" tooltipText={JOB_LEVEL_INFO} color="primary70" />
        </Label>
      </Row>
      <Row gridGap="S100">
        <Col width={'10%'}>
          <InputWrapper id="targetEmployeeJobLevels-condition6">
            {inputProps => (
              <Select disabled={isDisabled} options={['Equals']} {...inputProps} value={'Equals'} />
            )}
          </InputWrapper>
        </Col>
        <Col width={'50%'}>
          <MultiSelectInput
            disabled={isDisabled}
            elementId="targetEmployeeJobLevels"
            options={jobLevels}
            values={employeeJobLevels}
            onChangeHandler={e => {
              onJobLevelChange(e);
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default EmployeeJobLevelFilter;
